import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9u3ggd3pcjqs2fcsl8g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email, phone_alt: '' }).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们将定期为您推送黄油知识和优惠信息。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后重试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '提交失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="w-full max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-background-50/20 flex items-center justify-center">
          <span className="w-7 h-7 flex items-center justify-center text-background-50">
            <i className="ri-mail-send-line text-2xl"></i>
          </span>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          订阅黄油资讯
        </h2>
        <p className="text-background-100/80 text-sm md:text-base mb-8 max-w-md mx-auto">
          第一时间获取新品上架、黄油知识科普和专属优惠信息
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form=""
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 w-full sm:w-auto px-4 py-3 bg-background-50 rounded-md text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-6 py-3 bg-foreground-900 text-background-50 rounded-md text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap disabled:opacity-60 cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="anti-spam-field"
          />
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-background-100/90">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-background-100/90">{message}</p>
        )}
      </div>
    </section>
  );
}